module.exports = __webpack_public_path__ + "static/img/fullscreen-image_explore-your-options_fr_600.adcb2d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/fullscreen-image_explore-your-options_fr_600.png
// module id = B1D3
// module chunks = 0